import { render, staticRenderFns } from "./CalculatorPersonalGainAddPartner.vue?vue&type=template&id=09c33de7&scoped=true"
var script = {}
import style0 from "./CalculatorPersonalGainAddPartner.vue?vue&type=style&index=0&id=09c33de7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c33de7",
  null
  
)

export default component.exports